import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "col-md-6 mx-auto" }
const _hoisted_2 = { class: "dl-horizontal" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("dt", null, "ID", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("dt", null, "Name", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("dt", null, "Variant", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("dt", null, "Type", -1)
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("dt", null, "Max Round", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("dt", null, "Max Point", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("dt", null, "Table Credit Ratio", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("dt", null, "Cost", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("dt", null, "Cost Sates", -1)
const _hoisted_13 = { class: "raw" }
const _hoisted_14 = { class: "translated" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("dt", null, "Pot Rate Percents", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("dt", null, "Pot Rate Weights", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("dt", null, "Level Timeout", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("dt", null, "Finding Match Timeout", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("dt", null, "Win/Lose Group", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("dt", null, "Allow Invitation", -1)
const _hoisted_21 = { class: "card-footer bg-white border border-light" }
const _hoisted_22 = {
  key: 0,
  class: "col text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_card = _resolveComponent("app-card")!

  return (_openBlock(), _createBlock(_component_app_card, {
    class: "col-lg-8 mx-auto",
    label: "Match Detail "
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("dl", _hoisted_2, [
          _createElementVNode("tr", null, [
            _hoisted_3,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.id), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_4,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.name), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_5,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.variantOptions.find(v => v.value == _ctx.model.variantId)?.label), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_6,
            _createElementVNode("dd", {
              innerHTML: _ctx.renderOption(_ctx.GameMatchOptions.GameMatchType, _ctx.model.type)
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_8,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.maxRound), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_9,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.maxPoint), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_10,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.tableCreditRatio), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_11,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.costs), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_12,
            _createElementVNode("dd", null, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.model.costStates), 1),
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.GameMatchCostState.previewStates(_ctx.model.costStates)
                                    .map(s => s.label)
                                    .join(_ctx.GameMatchCostState.SEPARATOR)), 1)
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_15,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.potRatePercents), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_16,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.potRateWeights), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_17,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.levelTimeout), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_18,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.findingMatchTimeout), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_19,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.winLoseGroup ? 'True' : 'False'), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_20,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.allowInvitation ? 'True' : 'False'), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        (_ctx.model.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createVNode(_component_app_button, {
                name: "Edit",
                icon: "fa-edit",
                theme: "info",
                to: { name: _ctx.ROUTE_NAME_GAME.MATCH.EDIT, params: { id: _ctx.model.id } }
              }, null, 8, ["to"]),
              (_ctx.model.canDelete)
                ? (_openBlock(), _createBlock(_component_app_button, {
                    key: 0,
                    name: "Delete",
                    icon: "fa-trash-alt",
                    theme: "danger",
                    onClick: _withModifiers(_ctx.actions.remove, ["prevent"])
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}